"use client";

import styles from './index.module.scss';
import TextInput from "@/app/_components/Shared/TextInput";
import CustomSelect from "@/app/_components/Shared/CustomSelect";
import { emirates, employeeSizeOptions, proStaffingOptions } from '../data';

export default function CompanyDetails({data, onChange}) {
    return (
        <div className={styles.container}>
            <h2>Company Details</h2>
            <p className={styles.description}>Tell us about your business</p>

            <TextInput
                placeholder="Company Name"
                required
                value={data.companyName}
                onChange={(e) => onChange('companyName', e.target.value)}
            />

            <div className={styles.field}>
                <label>Emirate Location</label>
                <CustomSelect
                    options={emirates}
                    value={emirates.find(e => e.value === data.emirate)}
                    onChange={(selected) => onChange('emirate', selected?.value)}
                    placeholder="Select emirate (optional)"
                />
            </div>

            <div className={styles.field}>
                <label>Number of Employees</label>
                <CustomSelect
                    options={employeeSizeOptions}
                    value={employeeSizeOptions.find(e => e.value === data.employees)}
                    onChange={(selected) => onChange('employees', selected?.value)}
                    placeholder="Select company size (optional)"
                />
            </div>

            <div className={styles.radioGroup}>
                <label className={styles.radioLabel}>
                    Do you have a PRO service provider?
                </label>
                <div className={styles.radioOptions}>
                    {proStaffingOptions.map((option) => (
                        <div
                            key={option.value}
                            className={`${styles.radioCard} ${data.proStaffing === option.value ? styles.selected : ''}`}
                            onClick={() => onChange('proStaffing', option.value)}
                        >
                            <input
                                type="radio"
                                name="proStaffing"
                                value={option.value}
                                checked={data.proStaffing === option.value}
                                onChange={() => onChange('proStaffing', option.value)}
                            />
                            <div className={styles.radioContent}>
                                <span className={styles.radioTitle}>{option.label}</span>
                                <span className={styles.radioDescription}>{option.description}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
